<template>
    <!-- EVENT DETAILS -->
    <div id="modalCampos" class="modal">
        <div class="modal-content modal-historial">
            <div class="modal-header">
                <h6>Detalle Evento {{ selectedEvent.type }} </h6>
                <span @click="closeDialog" class="closeCampos close">&times;</span>
            </div>
            <div class="modal-body">
                <div class="row container-translucid m-1">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-4">
                                    <div class="row">
                                        <strong>Evento:</strong>
                                        <p>{{ selectedEvent.event_unit + selectedEvent.event_number }}</p>
                                    </div>
                                    <div class="row">
                                        <strong>Descripción:</strong>
                                        <p>{{ selectedEvent.description }}</p>
                                    </div>                                    
                                    <div class="row"><strong>Tipo</strong>
                                        <p>{{ selectedEvent.type }}</p>
                                    </div>
                                                                   
                            </div>
                            <div class="col-4"> 
                                 <div class="row"><strong>Mision</strong>
                                        <p>{{ selectedEvent.mission }}</p>
                                    </div>   
                                
                                <div class="row">
                                    <strong>Latitud</strong>
                                    <p>{{ selectedEvent.location.coordinates[1] }}</p>
                                </div>
                                <div class="row">
                                    <strong>Longitud</strong>
                                    <p>{{ selectedEvent.location.coordinates[0] }}</p>
                                </div>  
                            </div>

                            <div class="col-4">
                                <div class="row">
                                <strong>UTC:</strong>
                                <p>{{ selectedEvent.utc }}</p>
                                </div>
                                <div class="row">
                                    <strong>Estado</strong>
                                    <p>{{ selectedEvent.state }}</p>                                   
                                </div>
                                <div class="row">
                                    <strong>Alcance</strong>
                                    <p>{{ selectedEvent.scope }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-10">
                    </div>
                    <div class="col-2">
                        <button v-if="!isEmbeddedInMobileApp" class="btn btn-secondary btn-sm" @click="editEvent">Editar</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label>Medios asociados</label>
                        <div v-if="associatedMedia.length > 0 || associatedVideos.length > 0 || eventAttachments.length > 0" class="row tbl-container">
                            <div class="table-wrapper">
                            <table class="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th></th> <!-- Columna para los íconos -->
                                        <th>Nombre</th>
                                        <th>Fecha</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="media in eventAttachments" :key="media.id_event_attachment">
                                        <td><i class="bi bi-file-earmark"></i></td> <!-- Ícono para archivos -->
                                        <td><a target="_blank" :href="'fserver/documents' + media.file_path">{{ media.file_name }}</a></td>
                                        <td>{{ formatUtc(media.utc) }}</td>
                                    </tr>
                                    <tr v-for="media in associatedMedia" :key="media.photo_id">
                                        <td><i class="bi bi-image"></i></td> <!-- Ícono para fotos -->
                                        <td>{{ getFileNameFromPath(media.filename_jpg) }}</td>
                                        <td>{{ formatUtc(media.utc) }}</td>
                                    </tr>
                                    <tr v-for="video in associatedVideos" :key="video.file_id">
                                        <td><i class="bi bi-camera-reels"></i></td> <!-- Ícono para videos -->
                                        <td>{{ getFileNameFromPath(video.file_name) }}</td>
                                        <td>{{ formatUtc(extractUTCFromFilename(getFileNameFromPath(video.file_name))) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                        <div v-else>
                            <p>No hay medios asociados.</p>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
    <!-- FIN EVENT DETAILS -->
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import API from "../services";
import type { Evento, VideoFrame, EventAttachment } from '@/types';
import {useUtils} from '@/composables/useUtils';
import { useGlobalStore } from '@/stores/global';
import { storeToRefs } from 'pinia';

const { isEmbeddedInMobileApp } = storeToRefs(useGlobalStore());


const { getFileNameFromPath, extractUTCFromFilename, formatUtc } = useUtils();
const props = defineProps<{
    selectedEvent: Evento
}>()


const emit = defineEmits<{
    (event: 'closed'): void,
    (event: 'edit', evento: Evento): void
}>()

function closeDialog() {
    emit('closed')
}

const associatedMedia = ref<any[]>([]);
const associatedVideos = ref<VideoFrame[]>([]);
const eventCoordinates = ref({ lat: 0, lon: 0 }); 
const eventAttachments = ref<EventAttachment[]>([]); 

function editEvent() {
    emit('edit', props.selectedEvent);
}

async function fetchAssociatedMedia() {
  const filters = {
    lat_zona: eventCoordinates.value.lat,
    lon_zona: eventCoordinates.value.lon,
    rad_zona: 2, // Zona de 2
  };

  try {
    const photoResponse = await API.listPhotoFiles(filters);
    associatedMedia.value = photoResponse.data?.Entries?.Entry || []; // Manejo seguro de la estructura

    const videoResponse = await API.listVideoFrames(eventCoordinates.value.lat, eventCoordinates.value.lon);
    associatedVideos.value = videoResponse.data?.Entries?.Entry || []; // Manejo seguro de la estructura
  } catch (error) {
    console.error('Error al obtener medios asociados:', error);
  }
}
async function fetchEventAttachments(eventNumber: number) {
  try {
    const response = await API.getEventAttachments(eventNumber);
    eventAttachments.value = response.data.Entries.Entry || [];
    console.log('Adjuntos del evento:', eventAttachments.value);
  } catch (error) {
    console.error('Error al obtener los adjuntos del evento:', error);
  }
}
onMounted(() => {
  eventCoordinates.value.lat = props.selectedEvent.location.coordinates[1];
  eventCoordinates.value.lon = props.selectedEvent.location.coordinates[0];
  fetchAssociatedMedia();
  fetchEventAttachments(props.selectedEvent.event_number);
});
</script>
<style lang="css" scoped>

.modal {
    display: flex;
}

.modal-historial {
    max-width: 660px;
}

.modal-content {
    background-color: #0003;
    backdrop-filter: blur(5px);
    border: 1px solid #9f9f9f36;
    color: #ffffff;
   
}

.table>:not(caption)>*>* {
    background-color: #00000000;
    color: #ffffff;
    font-size: 12px;
}

.modal-header {
    padding: 10px;
    height: 30px;
    border-bottom: 1px solid #2d3e33;
    background-color: #353535;
}

.event-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 100vh; /* Limitar la altura al tamaño de la ventana */
  overflow-y: auto; /* Habilitar scroll vertical para el contenedor */
  position: relative; /* Asegurar que los controles sean visibles */
}

.event-details table {
  width: 100%; /* Asegurar que la tabla ocupe todo el ancho */
  max-height: 300px; /* Altura máxima de la tabla */
  overflow-y: auto; /* Habilitar scroll vertical */
  display: block; /* Asegurar que el scroll funcione */
}

.event-details thead {
  position: sticky;
  top: 0;
  background-color: #fff; /* Fondo blanco para que el encabezado sea visible */
  z-index: 1;
}

.event-details .controls {
  position: sticky;
  top: 0;
  background-color: #fff; /* Fondo blanco para que los controles sean visibles */
  z-index: 2;
  padding: 10px;
}

tbody {
  max-height: 100%;
  overflow-y: scroll;
}

.tbl-container {
    margin-left: 0;
    width: 100%;
    max-height: 35vh; /* Altura máxima del contenedor */
    overflow-y: auto; /* Habilitar scroll vertical */
    border: 1px solid #ccc; /* Borde para delimitar el área */
}


</style>